import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

/** Consome o pedido de extrato após carregar os registros autorizados da base. */
export function useStatementRequest<T extends { id: string }>(items: T[], ready: boolean, open: (item: T) => void, missing: () => void) {
  const [params, setParams] = useSearchParams()
  const id = params.get('extrato')
  const handled = useRef<string | null>(null)
  const actions = useRef({ open, missing })
  actions.current = { open, missing }

  useEffect(() => {
    if (!id) { handled.current = null; return }
    if (!ready || handled.current === id) return
    handled.current = id
    const next = new URLSearchParams(params)
    next.delete('extrato')
    setParams(next, { replace: true })
    const item = items.find(item => item.id === id)
    if (item) actions.current.open(item)
    else actions.current.missing()
  }, [id, ready, items, params, setParams])
}
